import {jwtServerInstance} from "../index";
import qs from	'qs'
import {getJwtToken} from "../../lib/utils";

export const getAllNoticeType = (pagination) =>{
    return jwtServerInstance.request({
        url:'/b2cnotice_type/all',
        method:'post',
        data:qs.stringify({
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}

export const getAllNotice = (queryForm, pagination) =>{
    return jwtServerInstance.request({
        url:'/b2cnotices/all',
        method:'post',
        data:qs.stringify({
            noticeType: queryForm.noticeType,
            noticeTitle: queryForm.noticeTitle,
            plateform: queryForm.plateform,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}


export const addNoticeType = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotice_type/add',
        method:'post',
        data:dialogForm
    })
}

export  const updateNoticeType = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotice_type/update',
        method:'post',
        data:dialogForm
    })
}

export const deleteNoticeType = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cnotice_type/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}

export const addNotice = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/add',
        method:'post',
        data:dialogForm
    })
}

export const updateNotice = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/update',
        method:'post',
        data:dialogForm
    })
}

export const updateNoticeIsNotToday = (b2cNoticesId) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/upisnottoday',
        method:'post',
        data:qs.stringify({
            b2cNoticesId: b2cNoticesId
        })
    })
}

export const deleteNotice = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/delete',
        method:'post',
        data:qs.stringify({
            id:dialogForm.id
        })
    })
}

export const queryNotice = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/query',
        method:'post',
        data:qs.stringify({
            keyWords: queryForm.noticeTitle,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const queryBusinessDataReport = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querybusinessreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            userId:queryForm.userId,
            userName: queryForm.userName,
            salemanName: queryForm.salemanName,
            ownerWeb:queryForm.ownerWeb,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryBusinessDataTotalReport = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/querybusinesstotalreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.userName,
            upSalemanName: queryForm.upBusinessName,
            businesstype: queryForm.businesstype,
        })
    })
}


export const querySalemanDataReport = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/querysalemanreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.userName,
            upSalemanName: queryForm.upBusinessName,
            businesstype: queryForm.businesstype,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const querySalemanDataTotalReport = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/querybusinesstotalreport',
        method:'post',
        data:qs.stringify({
            month:queryForm.month,
            salemanName: queryForm.userName,
            upSalemanName: queryForm.upBusinessName,
            businesstype: queryForm.businesstype,
        })
    })
}


export const queryCashOutInfo = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/query',
        method:'post',
        data:qs.stringify({
            userName: queryForm.userName,
            userType: queryForm.userType,
            status: queryForm.status,
            reviewUserName: queryForm.reviewUserName,
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryUserMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querybalancemoney',
        method:'post',
        data:qs.stringify({
            userId:queryForm.b2cUsersId
        })
    })
}

export const queryCashOutLimitMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querycashoutlimit',
        method:'post'
    })
}

export const commitCashOutMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/add',
        method:'post',
        data:queryForm
    })
}

export const queryCashOutPromptStr = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querycashoutstring',
        method:'post'
    })
}


export const changeCashOutMoneyStatus = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/update',
        method:'post',
        data:qs.stringify({
            transactionNumber: dialogForm.transactionNumber,
            id:dialogForm.id,
            status:dialogForm.status,
            remarks:dialogForm.remarks
        })
    })
}

export const changeCashOutMoneyStatusBatch = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/updatebatch',
        method:'post',
        data:dialogForm.b2cCashOutMoneyManages
    })
}

export const changeCashOutMoneyProcStatusBatch = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/updateprobatch',
        method:'post',
        data:dialogForm.b2cCashOutMoneyManages
    })
}


export const queryCashOutMoneyDayData = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/querycashmoney',
        method:'post',
        data:qs.stringify({
            userType:queryForm.usertype,
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryCashOutMoneyTotal = () => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/querycashouttotal',
        method:'post'
    })
}


export const queryBusinessMoneyDetails = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/accountchangerecords/querychangelogs',
        method:'post',
        data:qs.stringify({
            taskId: queryForm.taskId,
            orderId: queryForm.orderId,
            userName: queryForm.userName,
            shopInfo: queryForm.shopInfo,
            serialType: queryForm.serialType,
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const queryCashOutNumbersWithStatus = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querycashoutnumbers',
        method:'post',
        data: qs.stringify({
            roleId:queryForm.roleId,
            status:queryForm.statusStr
        })
    })
}

//参数配置列表查询接口
export const queryAppealList = (queryForm,pagination) => {
    return jwtServerInstance.request({
        url:'/b2cappealmessage/query',
        method:'post',
        data: qs.stringify({
            orderNumbers:queryForm.orderNumbers,
            userName:queryForm.createBy,
            appealType:queryForm.appealType,
            appealStatus:queryForm.appealStatus,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const commitAppealMessageInfo = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2cappealmessage/add',
        method:'post',
        data:dialogForm
    })
}


export const updateAppealMessageInfo = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2cappealmessage/update',
        method:'post',
        data:dialogForm
    })
}

export const updateBatchAppealMessageInfo = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2cappealmessage/updatebatch',
        method:'post',
        data:dialogForm
    })
}

export const commitAppealMessageRemarks = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2cappealmessage/addremarks',
        method:'post',
        data:qs.stringify({
            id:dialogForm.id,
            remarks:dialogForm.remarks
        })
    })
}

export const querySystemTaskTimeLimit = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2csystemtasktimelimit/query',
        method:'post'
    })
}

export const updateSystemTaskTimeLimit = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2csystemtasktimelimit/update',
        method:'post',
        data:dialogForm
    })
}


export const queryOrderProfit = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/queryorderprofit',
        method:'post',
        data:qs.stringify({
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryordercensus = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cadmindatacharts/queryordercensus',
        method:'post',
        data:qs.stringify({
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


export const getAllUserType = () =>{
    return jwtServerInstance.request({
        url:'/b2cuser_type/all',
        method:'post'
    });
}

export const queryMsgList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/imessagectr/querymsg',
        method:'post',
        data: qs.stringify({
            userName: queryForm.userName,
            msgStatus: queryForm.msgStatus,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}

export const queryUserMsgList = (queryForm)=>{
    return jwtServerInstance.request({
        url: '/imessagectr/queryusermsg',
        method: 'post',
        data:qs.stringify({
            activeUserName: queryForm.activeUserName
        })
    });
}

export const sendImageToServer = (file) =>{
    return jwtServerInstance.request({
        headers:{
            'Content-Type': 'multipart/form-data',
            'JWTHeaderName': getJwtToken()
        },
        url: '/taskservice/file/upload',
        method: 'post',
        data: file
    });
}

export const buildRentNumbers = (data)=>{
    return jwtServerInstance.request({
        url: '/rentmanage/build',
        method: 'post',
        data:qs.stringify({
            buildNumbers: data.rentNumbers,
            rentNumberPrice: data.rentNumberPrice,
            buildRole: data.rentRole
        })
    })
}

export const queryRentNumbers = (data, pagination)=>{
    return jwtServerInstance.request({
        url: '/rentmanage/query',
        method: 'post',
        data:qs.stringify({
            rentNumber: data.buildNumbers,
            rentStatus: data.buildRole,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const deleteRentNumbers = (data)=>{
    return jwtServerInstance.request({
        url: '/rentmanage/deleted',
        method: 'post',
        data:qs.stringify({
            id: data.id,
        })
    })
}

export const updateRentNumbers = (data)=>{
    return jwtServerInstance.request({
        url: '/rentmanage/update',
        method: 'post',
        data:qs.stringify({
            id: data.id,
            buildNumbers: data.buildNumbers,
            buildRole: data.buildRole
        })
    })
}

//新增一个刷新订单
export const reflushOrder = () =>{
    return jwtServerInstance.request({
        url:'/b2ctaskorder/refushorder',
        method:'post'
    })
}

